import { Box } from "@mui/material";
import { mediaUrl } from "../../../../utils/cfImage";

export default function ImageBackground(props) {
  const { component, slide } = props;

  const filesUrl = component.getHelpers("env").get("files_url");
  const imgVersion = component.getHelpers("value").getValue("images-version");

  const { slug, title, imagesPath } = slide || {}; // Fallback to empty object if slide is undefined

  if (!slide) {
    return null;
  }

  return (
    <>
      <picture>
        <source
          srcSet={[
            `${mediaUrl(`${filesUrl}${imagesPath}/${slug}-desktop.jpg`, { width: 1520, height: 911, version: imgVersion })} 1200w`,
            `${mediaUrl(`${filesUrl}${imagesPath}/${slug}-desktop.jpg`, { width: 1920, height: 1260, version: imgVersion })} 1500w`,
          ].join(", ")}
          media="(min-width: 900px)"
        />
        <img
          src={mediaUrl(`${filesUrl}${imagesPath}/${slug}-mobile.jpg`, {
                  width: 800,
                  height: 1200,
                  version: imgVersion,
                })}
          alt={title}
          loading="lazy"
          sizes="100vw"
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: -2,
          }}
        />
      </picture>
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: -1,
          bgcolor: "#b6b7ae",
          opacity: 0.5,
        }}
      />
    </>
  );
}
